<template>
  <div class="craft-portafolio">
    <div class="margin-general content">
      <div class="portafolio-items">
        <h2 v-html="formatContent(titleSection, $t, localPath)"></h2>
        <p class="desc">{{ $t(descriptionSection) }}</p>
        <p
          v-for="(item, index) in cards"
          :key="index"
          :class="index === activeSlide ? 'body-6-bold' : 'body-6'"
          class="linksText"
          @click="slideTo(index)"
        >
          {{ $t(item.name) }}
        </p>
      </div>
      <div class="carousel-container" :class="className">
        <swiper
          :modules="modules"
          :slidesPerView="1.5"
          :spaceBetween="15"
          :navigation="true"
          :loop="true"
          :initialSlide="initialSlide"
          class="slidePortafolio"
          @swiper="setSwiperRef"
          @slideChange="onSlideChange"
          effect="slide"
          :breakpoints="{
            '1500': {
              slidesPerView: 2.18,
              spaceBetween: 15,
              slidesPerGroup: 1, 
            },
            '750': {
              slidesPerView: 2.2,
              spaceBetween: 15,
              slidesPerGroup: 1, 
            },
            '569': {
              slidesPerView: 1.8,
              spaceBetween: 15,
              slidesPerGroup: 1, 
            },
            '375': {
              slidesPerView: 1.3,
              spaceBetween: 15,
              slidesPerGroup: 1, 
            },
            '100': {
              slidesPerView: 1.1,
              spaceBetween: 15,
              slidesPerGroup: 1, 
            },
          }"
        >
          <swiper-slide
            class="swiper-slide"
            v-for="(slide, j) in slider"
            :key="j"
            :style="slide.imgBackground ? { backgroundImage: `url(${slide.imgBackground})` } : {}"
          >
            <NuxtImg 
              v-if="slide.img"
              :src="slide.img"
              :alt="slide.alt"
              class="img-card"
              :width="slide.width || 400"
              :height="slide.height || 300"
              format="webp"
              quality="85"
              loading="lazy"
              decoding="async"
              sizes="sm:80vw md:60vw lg:50vw"
            />

            <div class="icon" v-if="slide.icon">
              <img :src="slide.icon"  :alt="slide.alt"/>
            </div>
            <div>
              <h4>{{ $t(slide.title) }}</h4>
              <p>{{ $t(slide.description) }}</p>
            </div>
          </swiper-slide>
          <NuxtLink :to="localPath('/trading/markets')" v-if="btn">
            <button class="body-4-bold second-button-small">
              {{ $t("craftPortafoleo.exploreButton") }}
            </button>
          </NuxtLink>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination, Navigation, Virtual, Autoplay } from "swiper/modules";
import { formatContent } from '~/utils/formatContent';
import { useLocalePath } from '#imports'; 
// Props
const props = defineProps({
  titleSection: String,
  descriptionSection: String,
  cards: Array,
  slider: Array,
  slidesPerView: Number,
  noSliderMobile: {
    default: false,
    type: Boolean,
  },
  btn: {
    default: true,
    type: Boolean,
  },
  className: {
    default: "",
    type: String,
  },
});

// Swiper modules y helpers
const modules = [Pagination, Navigation, Virtual, Autoplay];
const initialSlide = 0;
const localPath = useLocalePath();

// Estado reactivo
const activeSlide = ref(0);
const swiperRef = ref(null);

// Ciclo de vida
onMounted(() => {
  if (props.cards && props.cards.length) {
    activeSlide.value = 0;
  }
});

// Métodos
function setSwiperRef(swiper) {
  swiperRef.value = swiper;
}
function slideTo(index) {
  if (swiperRef.value) {
    swiperRef.value.slideToLoop(index);
  }
  activeSlide.value = index;
}
function onSlideChange(swiper) {
  activeSlide.value = swiper.realIndex;
}
</script>